import { render } from "./edit-category.vue?vue&type=template&id=c3e10796&scoped=true&ts=true"
import script from "./edit-category.vue?vue&type=script&lang=ts"
export * from "./edit-category.vue?vue&type=script&lang=ts"

import "./edit-category.vue?vue&type=style&index=0&id=c3e10796&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e10796"]])

export default __exports__